// AUTO-GENERATED by asyncapi-cable from the cable AsyncAPI documents.
// Do not edit by hand — regenerate with the asyncapi-cable CLI.

import { Channel } from "@anycable/core";
import type { HangarSyncFinishedMessage } from "../models/HangarSyncFinishedMessage";
import type { HangarSyncFailedMessage } from "../models/HangarSyncFailedMessage";
import type { HangarSyncCancelledMessage } from "../models/HangarSyncCancelledMessage";

/** Alternatives declared for the operation — AsyncAPI treats a channel's messages as a union. */
export type HangarSyncData = HangarSyncFinishedMessage | HangarSyncFailedMessage | HangarSyncCancelledMessage;

/** Params the client supplies at subscribe time. */
export type HangarSyncParams = Record<string, never>;

export class HangarSyncChannel extends Channel<HangarSyncParams, HangarSyncData> {
  static identifier = "HangarSyncChannel";
}
